import { defineMessages } from 'react-intl';
export default defineMessages({
    maxAmountInvestibleCurrentYear: {
        id: 'features.summaryTable.maxAmountInvestibleCurrentYear',
        defaultMessage: 'Importo massimo investibile anno in corso',
        description: 'text in the summary table page header max amount investable',
    },
    remainingInvestableCurrentYear: {
        id: 'features.summaryTable.remainingInvestableCurrentYear',
        defaultMessage: 'Residuo investibile anno in corso',
        description: 'text in the summary table page header remaining investable',
    },
    typology: {
        id: 'features.summaryTable.typology',
        defaultMessage: 'Tipologia',
        description: 'text in the summary table page header remaining investable - typology',
    },
    qualifiedTypology: {
        id: 'features.summaryTable.qualifiedTypology',
        defaultMessage: 'Qualificata',
        description: 'Qualificata',
    },
    notQualifiedTypology: {
        id: 'features.summaryTable.notQualifiedTypology',
        defaultMessage: 'Non Qualificata',
        description: 'Non Qualificata',
    },
    composition: {
        id: 'features.summaryTable.composition',
        defaultMessage: 'Composizione',
        description: 'text in the summary table page - composition',
    },
    total: {
        id: 'features.summaryTable.total',
        defaultMessage: 'Totale',
        description: 'text in the summary table page footer total',
    },
    productTitle: {
        id: 'features.summaryTable.productTitle',
        defaultMessage: 'Prodotto',
        description: 'Label product in summary table',
    },
    invested: {
        id: 'features.summaryTable.invested',
        defaultMessage: 'Investito',
        description: 'Label invested in summary table',
    },
    divested: {
        id: 'features.summaryTable.divested',
        defaultMessage: 'Disinvestito',
        description: 'Label divested in summary table',
    },
    commitment: {
        id: 'features.summaryTable.commitment',
        defaultMessage: 'Commitment',
        description: 'Label commitment in summary table',
    },
    commitmentBooked: {
        id: 'features.summaryTable.commitmentBooked',
        defaultMessage: 'Commitment/Partite prenotate',
        description: 'Label commitment in summary table',
    },
    concetration: {
        id: 'features.summaryTable.concetration',
    defaultMessage: '% Concentrazione',
        description: 'Label concetration in summary table',
    },
    disclaimer3: {
        id: 'features.summaryTable.disclaimer3',
    defaultMessage:
      '3: Le informazioni si riferiscono ai limiti da rispettare per ottenere il beneficio fiscale nell’anno di riferimento',
        description: 'text disclaimer under the table',
    },
    disclaimer4: {
        id: 'features.summaryTable.disclaimer4',
    defaultMessage:
      '4: Il valore è calcolato al netto di eventuali partite viaggianti e si riferisce ai limiti da rispettare per ottenere il beneficio fiscale nell’anno di riferimento',
        description: 'text disclaimer under the table',
    },
    disclaimer5: {
        id: 'features.summaryTable.disclaimer5',
    defaultMessage:
      '5: I valori indicati fanno riferimento alla data di ingresso delle quote nel deposito',
        description: 'text disclaimer under the table',
    },
    disclaimer6: {
        id: 'features.summaryTable.disclaimer6',
    defaultMessage:
      '6: Il valore è comprensivo delle partite prenotate quando presente e superata la data di avvaloramento prevista. Il valore della partita prenotata verrà riconsiderato con l’eseguito una volta pervenuto',
        description: 'text disclaimer under the table',
    },
    disclaimer7: {
        id: 'features.summaryTable.disclaimer7',
    defaultMessage: '7: Perdita del diritto al beneficio fiscale',
        description: 'text disclaimer under the table',
    },
    labelForContract: {
        id: 'features.summaryTable.labelForContract',
        defaultMessage: 'Contratto',
        description: 'Label contract in pir-box summary and details table',
    },
    labelEntireCMP: {
        id: 'features.summaryTable.labelEntireCMP',
        defaultMessage: 'CMP Complessivo',
        description: 'Label CMP in details table',
    },
    movementDate: {
        id: 'features.summaryTable.movementDate',
        defaultMessage: 'Data movimento',
        description: 'Label movement date',
    },
    currencyLabel: {
        id: 'features.summaryTable.currencyLabel',
        defaultMessage: 'Divisa',
        description: 'Label currencyLabel',
    },
    holdingMinimunPeriod: {
        id: 'features.summaryTable.holdingMinimunPeriod',
    defaultMessage: 'Holding period minimo',
        description: 'Label holding Minimun Period',
    },
    quantityLabel: {
        id: 'features.summaryTable.quantityLabel',
        defaultMessage: 'Quantità',
        description: 'Label quantity in product detail table',
    },
    noProductAvailable:{
      id: 'features.summaryTable.disclaimer1',
      defaultMessage:
        'Nessuna informazione da visualizzare',
      description: '',
    },
    disclaimer1: {
        id: 'features.summaryTable.disclaimer1',
    defaultMessage:
      '1: I valori indicati fanno riferimento alla data di ingresso delle quote nel deposito',
        description: 'first disclaimer displayed in detail product table',
    },
    disclaimer2: {
        id: 'features.summaryTable.disclaimer2',
    defaultMessage:
      '2: I valori indicati sono calcolati a livello di mandato di appartenenza per ciascun prodotto',
        description: 'second disclaimer displayed in detail product table',
    },
    PirBoxDate: {
        id: 'features.summaryTable.PirBoxDate',
        defaultMessage: 'Data perdita beneficio fiscale',
        description: 'PirBox Date',
    }
});
//# sourceMappingURL=data:application/json;base64,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
